<template>
  <el-container class="relative no-shrink-mobile">
    <div class="el-main my-classes"  v-loading="isLoading">
      <h2 style="margin-top: 0; text-align: center">My Classes</h2>
      <div class="container1300">
        <el-row :gutter="0" class="no-shrink home-categories" v-if="$store.state.classes.length">
          <el-col class="home-category " v-for="(c, i) in $store.state.classes" :key="i" :xs="24" :sm="12" :md="8"
                  :lg="6"
                  :xl="6">
            <div class="category-wrap">
              <div class="category">
                <div class="top">
                  <div class="class-name">{{c.name}}</div>
                  <div class="d-flex class-data">
                    <div class="students-count data">
                      <div class="title">Students</div>
                      <div class="d-flex">
                        <div class="icon">
                          <img src="/static/students.png" alt="">
                        </div>
                        <span class="value">{{c.students.length}}</span>

                      </div>
                    </div>
                    <div class="tours-count data">
                      <div class="title">Tours</div>
                      <div class="d-flex">
                        <div class="icon">
                          <img src="/static/layers.png" alt="">
                        </div>
                        <span class="value">{{c.demos ? c.demos.length : 0}}</span>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex-center w-100">
                  <router-link :to="'/class/'+c.id" class="btn"><span class="relative">View</span></router-link>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <div v-if="!$store.state.classes.length && !isLoading" class="no-data-block">
          <div class="flex-center">
            <div class="step-block d-flex" @click="createClassModal = true">
              <div class="step-number">
                <div><img src="/static/flag.svg" alt=""></div>
                <div>Step 1</div>
                <div class="bg-number">1</div>
              </div>
              <div class="step-name">
                Create a New<br>
                classroom
              </div>
            </div>
          </div>
          <div class="description">
            Classrooms is how you manage your students,
            inside a classroom you will be able to control list of your kids,
            assign them new tours and collect assessment results.
          </div>
          <div class="img-cnt flex-center">
            <img src="/static/create_class.png" alt="">
          </div>
        </div>
      </div>
      <div class="d-flex justify-center" v-if="!isLoading">
        <div class="btn-main shadowfloat" @click="createClassModal = true">Create Class</div>
      </div>
      <el-dialog
              class="signup-modal"
              title="Create class!"
              :visible.sync="createClassModal"
              width="30%"
              center>
        <div class="flex-center">Enter class name:</div>
        <div>
          <el-input placeholder="" v-model="className"
                    class="input-with-select search-cnt">
          </el-input>
        </div>
        <div class="d-flex justify-around" style="padding-top: 20px;">

          <el-button type="primary" @click.prevent='createClass'>Submit</el-button>
          <el-button type="success" @click.prevent='createClassModal = false'>Cancel</el-button>
        </div>
      </el-dialog>
    </div>
  </el-container>
</template>

<script>
  export default {
    name: 'myClasses',
    data () {
      return {
        className: "",
        isLoading: true,
        createClassModal: false,
      }
    },
    mounted: function () {
      this.axios.get(this.$store.state.API_URL + 'class/my')
        .then((res) => {
        this.isLoading = false;
          this.$store.commit("setState", {classes: res.data});
        });
    },
    methods: {
      createClass() {
        this.createClassModal = false;

        this.axios.post(this.$store.state.API_URL + 'class', {name: this.className}).then((res) => {
          let classes = this.$store.state.classes;
          classes.push(res.data);
          this.$store.commit("setState", {classes: classes});
//          this.$router.push("/class/" + res.data.id)
        });
      }
    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// src/pages/MyClasses.vue